// ----------------------------------------------------------------------------
// Template: Index
// ----------------------------------------------------------------------------
// Home Page Template
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import "sections/intro-block/intro-block";
import "sections/slim-banner/slim-banner";
import "sections/collection-list/collection-list";
import "sections/page-hero/page-hero";
import "sections/hero/hero";
import "sections/info-panel/info-panel";
import "sections/compare-block/compare-block";
import "sections/animated-panel/animated-panel";
import "sections/content-panel/content-panel";
import "sections/collapsible-content/collapsible-content";
import "sections/faqs/faqs";
import "sections/testimonial/testimonial";
import "sections/featured-collection/featured-collection";
import "sections/blog-posts/blog-posts";
import "sections/newsletter/newsletter";
import "sections/statements-block/statements-block";
import "sections/bundle-cards/bundle-cards";
import "sections/detailed-product/detailed-product";
import "sections/collections-carousel/collections-carousel";
import "sections/logo-list/logo-list";
import "sections/three-cards-section/three-cards-section";
import "sections/image-text-50-50/image-text-50-50";
import "sections/detailed-product-landing/detailed-product-landing";
import "sections/collage/collage";
import "sections/image-and-cards/image-and-cards";
import "sections/featured-collections/featured-collections";
import "sections/featured-reviews/featured-reviews";
import "sections/content-cards/content-cards";
import "sections/image-text-overlap/image-text-overlap";
import "sections/quote-block/quote-block";
import "sections/product-showcase/product-showcase";